import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/admins`,
  scopes: ExtHubRequest,
});
const SystemLogs = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/systemlogs`,
  scopes: ExtHubRequest,
});
const isdMarketing = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalISDMarketing`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'GetAgencyDetails' },
  { name: 'GetAgencyList' },
  { name: 'GetUserAzureID' },
  { name: 'deleteUser' },
  { name: 'GetFormStatusList' },
  { name: 'GetFormsOrders' },
  { name: 'GetFormsOrder' },
  { name: 'GetSecurityProfileList' },
  { name: 'GetSecurityProfileSettings' },
  { name: 'CreateSupportRegistration' },
  { name: 'deleteSupportRegistration' },
  { name: 'GetProducersByAgencyID' },
  { name: 'GetProducerDownstream' },
  { name: 'DeleteSupportRegistration' },
  { name: 'GetSupportRegistrationByBaseProducer' },
  { name: 'GenerateCode' },
  { name: 'UpdateEnabled' },
  { name: 'UpdateConvention' },
  { name: 'GetProducerDownlines' },
  { name: 'securelyGetProducerInformation' },
  { name: 'checkPermissionsToViewProducer' },
  { name: 'GetProducersByProducerID' },
  { name: 'GetProducersBySearchName' },
  { name: 'GetAgencyByTeamAgencyDescription' },
]);

SystemLogs.createEntities([{ name: 'getFailedRegs' }]);

isdMarketing.createEntities([
  { name: 'GetISDMarketingList' },
  { name: 'GetISDMarketingListAll' },
  { name: 'GetISDCategoryList' },
  { name: 'EmailForm' },
]);

const GetFailedRegs = (body) => SystemLogs.getFailedRegs.post(body);

const SecurelyGetProducerInformation = (body) =>
  api.endpoints.securelyGetProducerInformation.post(body);
const CheckPermissionsToViewProducer = (body) =>
  api.endpoints.checkPermissionsToViewProducer.post(body);

const GetAgencyByTeamAgencyDescription = (body) =>
  api.endpoints.GetAgencyByTeamAgencyDescription.post(body);
const GetProducersByProducerID = (body) => api.endpoints.GetProducersByProducerID.post(body);
const GetProducersBySearchName = (body) => api.endpoints.GetProducersBySearchName.post(body);
const GetProducerDownlines = (body) => api.endpoints.GetProducerDownlines.post(body);
const UpdateConvention = (body) => api.endpoints.UpdateConvention.post(body);
const UpdateEnabled = (body) => api.endpoints.UpdateEnabled.post(body);
const GenerateCode = (body) => api.endpoints.GenerateCode.post(body);
const GetProducersByAgencyID = (body) => api.endpoints.GetProducersByAgencyID.post(body);
const GetProducerDownstream = (body) => api.endpoints.GetProducerDownstream.post(body);
const GetSupportRegistrationByBaseProducer = (body) =>
  api.endpoints.GetSupportRegistrationByBaseProducer.post(body);
const DeleteSupportRegistration = (body) => api.endpoints.DeleteSupportRegistration.post(body);
const CreateSupportRegistration = (body) => api.endpoints.CreateSupportRegistration.post(body);
const GetSecurityProfileSettings = (body) => api.endpoints.GetSecurityProfileSettings.post(body);
const GetSecurityProfileList = (body) => api.endpoints.GetSecurityProfileList.post(body);
const GetFormsOrder = (body) => api.endpoints.GetFormsOrder.post(body);
const GetFormsOrders = (body) => api.endpoints.GetFormsOrders.post(body);
const GetFormStatusList = (body) => api.endpoints.GetFormStatusList.post(body);
const GetAgencyDetails = (body) => api.endpoints.GetAgencyDetails.post(body);
const GetUserAzureID = (UserID) => {
  const body = {
    UserID,
  };
  return api.endpoints.GetUserAzureID.post(body);
};
const GetAgencyList = () => api.endpoints.GetAgencyList.post();

const DeleteUser = (body) => api.endpoints.deleteUser.post(body);

const GetISDMarketingList = () => isdMarketing.endpoints.GetISDMarketingList.post();
const GetISDMarketingListAll = () => isdMarketing.endpoints.GetISDMarketingListAll.post();
const GetISDCategoryList = () => isdMarketing.endpoints.GetISDCategoryList.post();
const EmailForm = (body) => isdMarketing.endpoints.EmailForm.post(body);

export {
  api,
  GetAgencyDetails,
  GetAgencyList,
  GetUserAzureID,
  DeleteUser,
  GetFormStatusList,
  GetFormsOrders,
  GetFormsOrder,
  GetSecurityProfileList,
  GetSecurityProfileSettings,
  CreateSupportRegistration,
  DeleteSupportRegistration,
  GetSupportRegistrationByBaseProducer,
  GetProducerDownstream,
  GetProducersByAgencyID,
  GetFailedRegs,
  GenerateCode,
  UpdateEnabled,
  UpdateConvention,
  GetISDMarketingList,
  GetISDMarketingListAll,
  GetISDCategoryList,
  EmailForm,
  GetProducerDownlines,
  SecurelyGetProducerInformation,
  CheckPermissionsToViewProducer,
  GetProducersBySearchName,
  GetProducersByProducerID,
  GetAgencyByTeamAgencyDescription,
};
